/**
 * @generated SignedSource<<09d9943381c0ee532233ab0c4d4b436a>>
 * @relayHash f8586efc80ea28a4eafc78b9413f626e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 99aa9d7945ae892264764cfa6f33e773b4a15ec64bc45b6db2b6a04345af90fc

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type mergeReleaseModalQuery$variables = {
  projectAri: string;
  searchString?: string | null | undefined;
};
export type mergeReleaseModalQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"mergeReleaseModal_softwareReleasesReleaseModalsRelay_query">;
};
export type mergeReleaseModalQuery = {
  response: mergeReleaseModalQuery$data;
  variables: mergeReleaseModalQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectAri"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "searchString"
  }
],
v1 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": [
      "ARCHIVED",
      "UNRELEASED",
      "RELEASED"
    ]
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 6
  },
  {
    "kind": "Variable",
    "name": "jiraProjectId",
    "variableName": "projectAri"
  },
  {
    "kind": "Variable",
    "name": "searchString",
    "variableName": "searchString"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "mergeReleaseModalQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "FragmentSpread",
        "name": "mergeReleaseModal_softwareReleasesReleaseModalsRelay_query"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "mergeReleaseModalQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "id",
                "variableName": "projectAri"
              }
            ],
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "jiraProject",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ]
          },
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraVersionConnection",
            "kind": "LinkedField",
            "name": "versionsForProject",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraVersionEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "JiraVersion",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "name"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "__typename"
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "cursor"
                  }
                ]
              },
              {
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "endCursor"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "hasNextPage"
                  }
                ]
              },
              {
                "kind": "ClientExtension",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "__id"
                  }
                ]
              }
            ]
          },
          {
            "args": (v1/*: any*/),
            "filters": [
              "jiraProjectId",
              "filter",
              "searchString"
            ],
            "handle": "connection",
            "key": "mergeReleaseModal_versionsForProject",
            "kind": "LinkedHandle",
            "name": "versionsForProject"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "99aa9d7945ae892264764cfa6f33e773b4a15ec64bc45b6db2b6a04345af90fc",
    "metadata": {},
    "name": "mergeReleaseModalQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "18d434f389db050d0bda57545ded9c74";

export default node;
